"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mapInitialStateToStoreState_1 = __importDefault(require("../../utils/store/mapInitialStateToStoreState"));
const about_store_1 = __importDefault(require("./about.store"));
const airport_store_1 = __importDefault(require("./airport.store"));
const city_store_1 = __importDefault(require("./city.store"));
const cityBranch_store_1 = __importDefault(require("./cityBranch.store"));
/**  start-no-seo */
const faq_store_1 = __importDefault(require("./faq.store"));
/** end-no-seo */
const seopage_store_1 = __importDefault(require("./seopage.store"));
/**
 * CMS Page Store
 * Consumes
 *  About Store - about, t&c, privacy
 *  City, Airport, CityBranch
 *  FAQ Store
 */
class CmsPageStore {
    constructor(initialState = {}, $env) {
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
        // initialize domain stores
        /**  start-no-seo */
        this.faq = new faq_store_1.default(initialState.faq, $env);
        /** end-no-seo */
        this.about = new about_store_1.default(initialState.about, $env);
        this.airport = new airport_store_1.default(initialState.airport, $env);
        this.city = new city_store_1.default(initialState.city, $env);
        this.cityBranch = new cityBranch_store_1.default(initialState.cityBranch, $env);
        this.seoPage = new seopage_store_1.default(initialState.seoPage, $env);
    }
}
__decorate([
    mobx_1.action.bound
], CmsPageStore.prototype, "updateInitialState", void 0);
exports.default = CmsPageStore;
